import { Spin, Table } from "antd";
import ArchivosOrdenDePago from "../ordenes-archivos/ordenes-archivos.component";
import AlertMessage from "../alert-message/alert-message.component";
import { adapterOrdenesFromApi, toTableData } from "../../adapters/ordenes-pago.adapter";
import moment from "moment";
import { currencyFormat } from "../../utils/utils";

const MESSAGE_INFO='Tenga en cuenta que los comprobantes de retención y/o pago pueden demorar hasta 2 días hábiles, contados desde la realización de la transferencia, en estar disponibles para su visualización en la web. Muchas gracias!';

const table_columns = [
    {
        title: "Nro Órden",
        dataIndex: "nro",
        // specify the condition of filtering result
        // here is that finding the name started with `value`
        sorter: (a, b) => a.nro - b.nro,
    },
    {
        title: "Fecha",
        dataIndex: "fecha",
        defaultSortOrder: "descend",
        sorter: (a, b) => moment(a.fecha).unix() - moment(b.fecha).unix(),
    },
    {
        title: "Importe",
        dataIndex: "importe",
        sorter: (a, b) => a.importe - b.importe,
        render: (importe) =>
            currencyFormat(importe.toString().replace(/\./g, ",")),
    },
    {
        title: "Concepto",
        dataIndex: "concepto",
        sorter: (a, b) => a.concepto - b.concepto,
    },
    {
        title: "Archivos",
        dataIndex: "archivos",
        render: (archivos) => <ArchivosOrdenDePago archivos={archivos} />,
    },
];

const OrdenesDePagoTable = ({ loading, loadingMessage, data, infoMessage, successMessage }) => {
	return (  
		<div className='content'>
			{loading ? (
				<Spin tip={loadingMessage} />
			) : data?.length === 0 ? (
				<AlertMessage message={infoMessage} type='info' />
			) : (
				<>
					<AlertMessage message={MESSAGE_INFO} type='info' />
					<AlertMessage
						message={successMessage}
						type='success'
					/>
					<Table
						columns={table_columns}
						dataSource={toTableData(adapterOrdenesFromApi(data))}
					/>
				</>
			)}
		</div>
	);
}
 
export default OrdenesDePagoTable;